import {
  AndFilter,
  AnyFilterExpressionInput,
  Field,
  FilterOp,
  MaintenanceDto,
  ObjectType,
} from "gql/generated/types";
import { ColumnBodyOptions, ColumnProps } from "primereact/column";
import { DataTableStateEvent } from "primereact/datatable";
import React from "react";
import { Path } from "react-hook-form";
import { StringKey } from "services/lang/keys";
import { DweenColors } from "utils/enums";

export type TableOptions = DataTableStateEvent & {
  filter: AnyFilterExpressionInput | null;
  andFilters: AndFilter[];
  search: string;
  reqSortField: string;
};

export type TagSeverityType =
  | "success"
  | "info"
  | "warning"
  | "danger"
  | "secondary"
  | "contrast"
  | null
  | undefined;

export type FilterField = Field;

export type FilterInternal = {
  fields: FilterField[];
  value: string | null | string[];
  cond: FilterOp;
  label: string;
  id: string;
};

export type TableColumn<T> = Omit<ColumnProps, "field" | "header" | "body"> & {
  header: string;
  field?: Path<T>;
  body?: React.ReactNode | ((data: T, options: ColumnBodyOptions) => React.ReactNode);
  hideInFile?: boolean;
  columnKey: string;
};

type ObjectTypeUnion = keyof typeof ObjectType;

export type MdmTableName =
  | "Devices"
  | "ChildDevices"
  | "DevicesByObject"
  | "NodesByObject"
  | "Objects"
  | "Apartments"
  | "Antennas"
  | "Analytics"
  | "AnalyticsByObject"
  | "Maintenance"
  | "Jobs"
  | "JobsByObject"
  | ObjectTypeUnion;

export type MdmContainerName =
  | "MdmDevice"
  | "MdmObject"
  | "AnalyticsResult"
  | "MdmMaintenance"
  | "MdmAntenna";

export type CustomRowData = Record<
  string,
  { value: string | number | null; id: string; title: string } | null
>;

export type StatusInfo = {
  value: Status;
  severity: TagSeverityType;
  translationKey: StringKey;
  bgColor: DweenColors;
};

export type PriorityInfo = {
  value: string;
  severity: string;
  icon: string;
  translationKey: StringKey;
};

export type LoadingStates = {
  excel?: boolean;
  csv?: boolean;
};

export const statuses = [
  "REGISTERED",
  "PLANNED",
  "IN_PROGRESS",
  "DONE",
  "CANCELLED",
  "EXTENDED",
  "COORDINATED",
  "TODO",
  "DELAYED",
] as const;

export type Status = (typeof statuses)[number];
export type MaintenanceStatus = Exclude<Status, "TODO">;

export type MaintenanceEmail = {
  triggerFrom: Status;
  triggerTo: Status;
  header: string;
  recipientsTo: string[];
  recipientsCc: string[];
  text: string;
};

export type StatusTrigger = {
  from: MaintenanceStatus | null;
  to: MaintenanceStatus | null;
};

export type SummaryMaintenance = {
  id: string;
  maintenance: MaintenanceDto;
  identifier: string;
  address: string;
};
